/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import { HttpErrorCodes } from './HttpErrorCodes';

const errorCode = [
  {
    HTTP_ERROR_CODE: HttpErrorCodes.HTTP_ERROR_CODE_400,
    ERROR_MESSAGE: 'Http Error: 400 - Malformed or illegal request',
    DISPLAY_ERROR: 'DISPLAY_ON_COMPONENT',
  }, //SAME PAGE
  {
    HTTP_ERROR_CODE: HttpErrorCodes.HTTP_ERROR_CODE_401,
    ERROR_MESSAGE:
      'Http Error: 401 - The combination of Email and password is incorrect, please enter the correct Email and password',
    DISPLAY_ERROR: 'DISPLAY_ON_COMPONENT',
  }, //SAME PAGE
  {
    HTTP_ERROR_CODE: HttpErrorCodes.HTTP_ERROR_CODE_403,
    ERROR_MESSAGE:
      "Http Error: 403 - Forbidden: You don't have permission to access the resource",
    DISPLAY_ERROR: 'DISPLAY_ON_COMPONENT',
  }, //SAME PAGE
  {
    HTTP_ERROR_CODE: HttpErrorCodes.HTTP_ERROR_CODE_404,
    ERROR_MESSAGE:
      'Http Error: 404 - The resource you are looking for might have been removed, changed, or is temporarily unavailable',
    DISPLAY_ERROR: 'DISPLAY_ON_COMPONENT',
  }, //SAME PAGE
  {
    HTTP_ERROR_CODE: HttpErrorCodes.HTTP_ERROR_CODE_405,
    ERROR_MESSAGE:
      'Http Error: 405 - The requested operation cannot be performed',
    DISPLAY_ERROR: 'DISPLAY_ON_COMPONENT',
  }, //SAME PAGE
  {
    HTTP_ERROR_CODE: HttpErrorCodes.HTTP_ERROR_CODE_407,
    ERROR_MESSAGE:
      'Http Error: 407 - The requested operation cannot be performed',
    DISPLAY_ERROR: 'DISPLAY_ON_COMPONENT',
  }, //SAME PAGE
  {
    HTTP_ERROR_CODE: HttpErrorCodes.HTTP_ERROR_CODE_408,
    ERROR_MESSAGE:
      'Http Error: 408 - The client did not produce a request within the time that the server was prepared to wait.',
    DISPLAY_ERROR: 'DISPLAY_ON_COMPONENT',
  }, //SAME PAGE
  {
    HTTP_ERROR_CODE: HttpErrorCodes.HTTP_ERROR_CODE_410,
    ERROR_MESSAGE:
      'Http Error: 410 - The requested page is permanently deleted',
    DISPLAY_ERROR: 'REDIRECT_TO_ERROR_PAGE',
  }, //REDIRECT TO ERROR PAGE
  {
    HTTP_ERROR_CODE: HttpErrorCodes.HTTP_ERROR_CODE_415,
    ERROR_MESSAGE: 'Http Error: 415 - Unsupported media type',
    DISPLAY_ERROR: 'DISPLAY_ON_COMPONENT',
  }, //SAME PAGE
  {
    HTTP_ERROR_CODE: HttpErrorCodes.HTTP_ERROR_CODE_422,
    ERROR_MESSAGE: 'Http Error: 422 - Unprocessable entity',
    DISPLAY_ERROR: 'DISPLAY_ON_COMPONENT',
  }, //SAME PAGE
  {
    HTTP_ERROR_CODE: HttpErrorCodes.HTTP_ERROR_CODE_429,
    ERROR_MESSAGE: 'Http Error: 429 - Too many requests. Server busy',
    DISPLAY_ERROR: 'REDIRECT_TO_ERROR_PAGE',
  }, //REDIRECT TO ERROR PAGE
  {
    HTTP_ERROR_CODE: HttpErrorCodes.HTTP_ERROR_CODE_500,
    ERROR_MESSAGE: 'Http Error: 500 - Server unavailable',
    DISPLAY_ERROR: 'REDIRECT_TO_ERROR_PAGE',
  }, //REDIRECT TO ERROR PAGE
  {
    HTTP_ERROR_CODE: HttpErrorCodes.HTTP_ERROR_CODE_501,
    ERROR_MESSAGE: 'Http Error: 501 - The requested method is not implemented',
    DISPLAY_ERROR: 'REDIRECT_TO_ERROR_PAGE',
  }, //REDIRECT TO ERROR PAGE
  {
    HTTP_ERROR_CODE: HttpErrorCodes.HTTP_ERROR_CODE_502,
    ERROR_MESSAGE:
      'Http Error: 502 - Bad Gateway: Server is unable to fulfill the request',
    DISPLAY_ERROR: 'REDIRECT_TO_ERROR_PAGE',
  }, //REDIRECT TO ERROR PAGE
  {
    HTTP_ERROR_CODE: HttpErrorCodes.HTTP_ERROR_CODE_503,
    ERROR_MESSAGE: 'Http Error: 503 - Service temporarily unavailable',
    DISPLAY_ERROR: 'REDIRECT_TO_ERROR_PAGE',
  }, //REDIRECT TO ERROR PAGE
  {
    HTTP_ERROR_CODE: HttpErrorCodes.HTTP_ERROR_CODE_504,
    ERROR_MESSAGE: 'Http Error: 504 - Gateway timeout',
    DISPLAY_ERROR: 'REDIRECT_TO_ERROR_PAGE',
  }, //REDIRECT TO ERROR PAGE

  {
    HTTP_ERROR_CODE: HttpErrorCodes.HTTP_REQUEST_ABORTED,
    ERROR_MESSAGE: 'Http Request Aborted',
    DISPLAY_ERROR: 'REDIRECT_TO_ERROR_PAGE',
  }, //REDIRECT TO ERROR PAGE
];

class HttpErrorHandler {
  constructor() {
    this.ErrorCode = '';
    this.Status = '';
    this.ErrorMessage = '';
    this.ErrorInfo = '';
    this.Image = '';
    this.Router = '';
    this.Data = '';
  }

  setErrorMessage(errorMessage) {
    this.ErrorMessage = errorMessage;
  }

  getErrorMessage() {
    return this.ErrorMessage;
  }

  DisplayServerErrorMessage(error, errorMessage) {
    let iIndex,
      bGenericError = true;

    for (iIndex = 0; iIndex < errorCode.length; iIndex++) {
      if (error == errorCode[iIndex].HTTP_ERROR_CODE) {
        console.log('Error Codes Length: ', errorCode.length);
        console.log(errorCode[iIndex].ERROR_MESSAGE);
        bGenericError = false;
        if (errorCode[iIndex].DISPLAY_ERROR == 'REDIRECT_TO_ERROR_PAGE') {
          console.log('Redirect to Error Page');
          this.router = '/servererror';
          this.setErrorMessage(errorMessage);
        } else {
          console.log('Display Error on the same page');
        }
        break;
      }
    }

    if (bGenericError) {
      console.log('Http Error ' + error + ' :Something went wrong');
      //Redirect
    }
  }

  //Error handling for Client errors
  ProcessedClientErrors(ErrorCode, ErrorMessage) {
    let ComposedErrorMessage = '';
    let processedClientError = true;

    switch (true) {
      case ErrorCode === HttpErrorCodes.HTTP_ERROR_CODE_401:
        console.log('Error Code: ', ErrorCode);
        ComposedErrorMessage =
          'Sorry, you are not authorized to ' +
          ErrorMessage +
          ' Contact our customer support team:';
        break;

      case ErrorCode === HttpErrorCodes.HTTP_ERROR_CODE_403:
        console.log('Error Code: ', ErrorCode);
        ComposedErrorMessage =
          'Sorry, you are not authorized to ' +
          ErrorMessage +
          ' Contact our customer support team:';
        break;

      case ErrorCode === HttpErrorCodes.HTTP_ERROR_CODE_404:
        console.log('Error Code: ', ErrorCode);
        ComposedErrorMessage =
          'Sorry, you cannot ' + ErrorMessage + 'No data available.';
        break;

      case ErrorCode === HttpErrorCodes.HTTP_ERROR_CODE_405:
        console.log('Error Code: ', ErrorCode);
        ComposedErrorMessage =
          'Sorry, you are not authorized to ' +
          ErrorMessage +
          ' Contact our customer support team:';
        break;

      case ErrorCode === HttpErrorCodes.HTTP_ERROR_CODE_407:
        console.log('Error Code: ', ErrorCode);
        ComposedErrorMessage =
          'Sorry, you are not authorized to ' +
          ErrorMessage +
          ' Contact our customer support team:';
        break;

      default:
        processedClientError = false;
        break;
    }

    this.setErrorMessage(ComposedErrorMessage);
    this.DisplayServerErrorMessage(errorCode, ComposedErrorMessage);
    return processedClientError;
  }

  //Error handling for Client errors
  ProcessedException(ErrorCode, ErrorMessage) {
    let ComposedErrorMessage = '';

    switch (true) {
      case ErrorCode === HttpErrorCodes.HTTP_ERROR_CODE_408:
        console.log('Error Code: ', ErrorCode);
        ComposedErrorMessage =
          'Sorry, ' +
          ErrorMessage +
          ' Try after some time or contact our customer support team:';
        break;

      case ErrorCode === HttpErrorCodes.HTTP_ERROR_CODE_410:
        console.log('Error Code: ', ErrorCode);
        ComposedErrorMessage =
          'Sorry, ' +
          ErrorMessage +
          ' Try after some time or contact our customer support team:';
        break;

      case ErrorCode === HttpErrorCodes.HTTP_ERROR_CODE_404:
        console.log('Error Code: ', ErrorCode);
        ComposedErrorMessage =
          'Sorry, ' + ErrorMessage + ' contact our customer support team:';
        break;

      case ErrorCode >= HttpErrorCodes.HTTP_ERROR_CODE_429:
        console.log('Error Code: ', ErrorCode);
        ComposedErrorMessage =
          'Sorry, ' +
          ErrorMessage +
          ' Try after some time or contact our customer support team:';
        break;

      default:
        ComposedErrorMessage =
          'Sorry, ' +
          ErrorMessage +
          ' Try after some time or contact our customer support team:';
        break;
    }
    console.log('ComposedErrorMessage >>>>> ', ComposedErrorMessage);
    this.setErrorMessage(ComposedErrorMessage);
    this.DisplayServerErrorMessage(errorCode, ComposedErrorMessage);
    return true;
  }
}

export default new HttpErrorHandler();
